import axios from "axios";
import { getDeviceId, setAuthHint } from "../utils/device";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
  withCredentials: true,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 15000,
});

// Session codes returned by the gateway when a session is missing or ended.
const SESSION_END_CODES = new Set([
  "NOT_AUTHENTICATED",
  "DEVICE_REQUIRED",
  "SESSION_INVALID",
  "SESSION_REVOKED",
  "SESSION_EXPIRED",
  "SESSION_DEVICE_MISMATCH",
  "ACCOUNT_INACTIVE",
]);

api.interceptors.request.use((config) => {
  config.headers["X-Client-App"] = "customer";
  config.headers["X-Device-Id"] = getDeviceId();
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const code = error.response?.data?.code;

    if (
      error.response?.status === 503 &&
      code === "MAINTENANCE_MODE"
    ) {
      window.dispatchEvent(
        new CustomEvent("storefront-maintenance", {
          detail: error.response.data.data,
        })
      );
    }

    if (SESSION_END_CODES.has(code)) {
      setAuthHint(false);

      window.dispatchEvent(
        new CustomEvent("auth-session-ended", { detail: { code } })
      );

      if (!originalRequest?.skipAuthRedirect && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
